import React, { useEffect, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";

import {
    ListarProdutosPorContaCompleto,
    VerificaProdutoAdimplenteController,
} from "../../../../Controllers/Cobranca/ContaProduto/ContaProdutoController";
import { IContaProduto } from "../../../../Interfaces/Cobranca/ContaProduto/ContaProdutoInterface";

import "../styles.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface IProdutosHorizontalProps {
    idConta: number;
    idProdutoAtendimento: number;
}
export default function ProdutosHorizontal(props: IProdutosHorizontalProps) {
    const [lstProdutos, setLstProdutos] = useState<Array<IContaProduto>>([]);

    const [statuses, setStatuses] = useState<(boolean | null)[]>([]);
    const [verificandoAdimplencia, setVerificandoAdimplencia] = useState(true);

    useEffect(() => {
        if (props.idConta) {
            updateProdutos({
                idConta: props.idConta,
                idProdutoAtendimento: props.idProdutoAtendimento,
            });
        }
    }, [props.idConta, props.idProdutoAtendimento]);

    function updateProdutos(props: IProdutosHorizontalProps) {
        ListarProdutosPorContaCompleto(props.idConta, 0).then((res) => {
            //encontra o produto do atendimento, retira ele do vetor e o insere no início
            const ProdutoAtendido = res.find(
                (val) => val.UNIDADE.ID_UNIDADE === props.idProdutoAtendimento
            );
            if (ProdutoAtendido)
                res.unshift(res.splice(res.indexOf(ProdutoAtendido), 1)[0]);

            setLstProdutos(res);
        });
    }

    useEffect(() => {
        const fetchData = async () => {
            if (lstProdutos && lstProdutos.length > 0) {
                try {
                    const statusesArray = await Promise.all(
                        lstProdutos?.map(async (produto) => {
                            try {
                                if (produto.UNIDADE.ID_CHAVE_ERP_VENDA) {
                                    const res =
                                        await VerificaProdutoAdimplenteController(
                                            produto.UNIDADE.ID_CHAVE_ERP_VENDA
                                        );
                                    return res;
                                } else {
                                    return null;
                                }
                            } catch (error) {
                                return null;
                            }
                        }) || []
                    );

                    setStatuses(statusesArray);
                } finally {
                    setVerificandoAdimplencia(false);
                }
            }
        };

        fetchData();
    }, [lstProdutos]);

    return lstProdutos.length ? (
        <div className="card card-custom w-auto gutter-b">
            {lstProdutos && <h3 className="pl-2 pt-2">Produtos</h3>}
            <div className="d-flex produtosHCard x-scroll">
                {lstProdutos.map((produto, index) => {
                    const isProdutoAtendido =
                        produto.UNIDADE.ID_UNIDADE ===
                        props.idProdutoAtendimento;

                    const adimplenciaValue = statuses[index];

                    const semChaveErp =
                        produto.UNIDADE.ID_CHAVE_ERP_VENDA === null ||
                        produto.UNIDADE.ID_CHAVE_ERP_VENDA === "";

                    const getStatusClass = () => {
                        if (semChaveErp) {
                            return "symbol-light-dark";
                        } else if (
                            verificandoAdimplencia ||
                            adimplenciaValue === null
                        ) {
                            return "symbol-light-warning";
                        } else {
                            return adimplenciaValue
                                ? "symbol-light-danger"
                                : "symbol-light-success";
                        }
                    };

                    return (
                        <div
                            key={index}
                            className={`d-flex flex-nowrap align-items-center justify-content-center p-1 unidadeHCard ${
                                isProdutoAtendido &&
                                "ribbon ribbon-clip ribbon-left"
                            }`}
                        >
                            {isProdutoAtendido && (
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="tooltip-disabled">
                                            Produto em Atendimento
                                        </Tooltip>
                                    }
                                >
                                    <div
                                        className="ribbon-target"
                                        style={{ top: "2px" }}
                                    >
                                        <span className="ribbon-inner bg-warning"></span>
                                        <i className="fa fa-star text-white"></i>
                                    </div>
                                </OverlayTrigger>
                            )}
                            <div
                                className={`symbol symbol-45 symbol-light-${getStatusClass()}`}
                            >
                                <div className="symbol-label">
                                    <FontAwesomeIcon icon={faHome} size="lg" />
                                </div>
                            </div>

                            <div className="text-left ml-2">
                                <div className="font-weight-bolder">
                                    {produto.DS_EMPREENDIMENTO}
                                </div>
                                <div>{produto.UNIDADE.DS_UNIDADE}</div>
                                <div className="d-flex justify-content-end">
                                    {produto.UNIDADE.ID_CHAVE_ERP_VENDA && (
                                        <span className="label label-light-success label-inline ml-2">
                                            {produto.UNIDADE.ID_CHAVE_ERP_VENDA}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    ) : (
        <div></div>
    );
}
